interface Risk {
  id: string
  condition: string
  risk_low: number
  risk_high: number
  modifiable_fraction: number
  pattern_type: string
  supporting_members: string[]
  description: string
}

export default function RiskBar({ risk }: { risk: Risk }) {
  const midRisk = ((risk.risk_low + risk.risk_high) / 2) * 100
  const modifiable = risk.modifiable_fraction * 100

  return (
    <div className="bg-white border border-gray-200 rounded-lg p-4 shadow-sm">
      <div className="flex items-start justify-between mb-2">
        <div>
          <p className="text-sm font-semibold text-gray-800 capitalize">
            {risk.condition.replace(/_/g, ' ')}
          </p>
          <p className="text-xs text-gray-500 capitalize">{risk.pattern_type} pattern</p>
        </div>
        <span className="text-sm font-bold text-gray-700">{midRisk.toFixed(0)}%</span>
      </div>

      <div className="relative h-2 bg-gray-100 rounded-full overflow-hidden">
        <div
          className="absolute h-full bg-red-300 rounded-full"
          style={{ width: `${risk.risk_high * 100}%` }}
        />
        <div
          className="absolute h-full bg-red-500 rounded-full"
          style={{ width: `${risk.risk_low * 100}%` }}
        />
      </div>

      <div className="flex items-center justify-between mt-2 text-xs text-gray-400">
        <span>{Math.round(risk.risk_low * 100)}%–{Math.round(risk.risk_high * 100)}% range</span>
        <span className="text-green-600">{modifiable.toFixed(0)}% modifiable</span>
      </div>

      {risk.supporting_members.length > 0 && (
        <p className="text-xs text-gray-400 mt-1">
          Observed in: {risk.supporting_members.join(', ')}
        </p>
      )}
    </div>
  )
}
